import { jsx as _jsx } from "react/jsx-runtime";
import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNewTab } from 'shared';
import { useGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery } from 'consumer-applications-v2-api';
import { setPrequalification } from '../actions';
import { selectors } from '../reducer';
import ImprintCashFlowModal from './ImprintCashFlowModal';
function ImprintCashFlowModalShell({ isCashFlowModalOpen, setIsCashFlowModalOpen, offer, setCashFlowBrowserResponse, cashFlowBrowserResponse, }) {
    const dispatch = useDispatch();
    const prequalification = useSelector(selectors.prequalification);
    const { setNewTab, closeNewTab } = useNewTab(() => {
        setCashFlowBrowserResponse('SUCCESS');
        setAwaitingCashFlowResponse(false);
        setShouldPoll(true);
    });
    const [awaitingCashFlowResponse, setAwaitingCashFlowResponse] = useState(false);
    const [shouldPoll, setShouldPoll] = useState(false);
    const { data, isError: isErrorPolling } = useGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery(shouldPoll
        ? {
            applicationId: prequalification.applicationId,
        }
        : skipToken, { pollingInterval: 3000, skipPollingIfUnfocused: true });
    const handleLinkBankAccount = () => {
        const newTab = window.open(offer.cashflowUnderwriting?.url, '_blank', 'width=600,height=1000');
        newTab && setNewTab(newTab);
        setAwaitingCashFlowResponse(true);
    };
    const handleContinueWithCurrentOffer = () => {
        setIsCashFlowModalOpen(false);
    };
    const handleRefreshCurrentOffer = () => {
        setCashFlowBrowserResponse('SUCCESS');
        setShouldPoll(true);
    };
    useEffect(() => {
        const cashflowUnderwriting = data?.offers?.find((o) => o.offerId === offer.offerId)?.cashflowUnderwriting;
        if (data &&
            cashflowUnderwriting &&
            cashflowUnderwriting.status !== 'created') {
            dispatch(setPrequalification(data));
            setIsCashFlowModalOpen(false);
            setShouldPoll(false);
        }
        if (isErrorPolling) {
            setIsCashFlowModalOpen(false);
            setShouldPoll(false);
        }
    }, [data, isErrorPolling]);
    useEffect(() => {
        if (cashFlowBrowserResponse === 'SUCCESS') {
            setShouldPoll(true);
        }
        if (cashFlowBrowserResponse === 'INTERNAL_ERROR') {
            setIsCashFlowModalOpen(false);
        }
    }, [cashFlowBrowserResponse, offer]);
    useEffect(() => {
        const handler = async (event) => {
            if (offer.cashflowUnderwriting?.url.includes(event.origin)) {
                setCashFlowBrowserResponse(event.data?.data?.status);
                closeNewTab();
            }
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, [closeNewTab, offer.cashflowUnderwriting?.url]);
    return (_jsx(ImprintCashFlowModal, { isOpen: isCashFlowModalOpen, setIsOpen: setIsCashFlowModalOpen, handleLinkBankAccount: handleLinkBankAccount, handleContinueWithCurrentOffer: handleContinueWithCurrentOffer, handleRefreshCurrentOffer: handleRefreshCurrentOffer, isRefreshing: shouldPoll, awaitingCashFlowResponse: awaitingCashFlowResponse || shouldPoll, hideModalClose: awaitingCashFlowResponse, amount: offer.amount }));
}
export default ImprintCashFlowModalShell;
